// extracted by mini-css-extract-plugin
export default {"input":"C8-z","button":"D8-z","selected":"E8-z","unavailable":"F8-z","oos":"G8-z","image":"H8-z","paperCutDisabledOverlay":"I8-z"};